/* eslint-disable no-unused-vars */

// eslint-disable-next-line no-unused-vars
export const BASE_URL = window.localStorage.getItem("BASE_URL");
export const API_URL = window.localStorage.getItem("API_URL");
export const APP_NAME = "InfoxIT Dairy ERP - Control Panel";
export const dataSitekey = window.localStorage.getItem("data_sitekey");
export const isSelenium = window.localStorage.getItem("seleniumTest", false);
export const entry_modules = {
  "milk-purchase-party": "Milk Purchase Party", //master
  routes: "Routes",
  "sales-person-entry": "Sales Person Entry",
  "product-master": "Product Master",
  product: "Product",
  party: "Party",
  rate: "Rate",
  container: "Container",
  commission: "Commission",
  branch: "Branch",
  "milk-man-or-farmer-register": "Milk Man/Farmer Reg",
  "milk-purchase-entry": "Milk Purchase Entry", //Purchase Cycle
  "purchase-entry": "Purchase Entry",
  "purchase-return": "Purchase Return",
  "payment-entry": "Payment Entry",
  "production-entry": "Production Entry", //Production Cycle
  "manage-production-entry": "Manage Production Entry",
  "order-entry": "Order Entry", //Order Processing
  "container-in-out-entry": "Container In/Out Entry", //Sales Cycle
  "sales-chalan-entry": "Sales Chalan Entry",
  "pos-sales-entry": "POS Sales Entry",
  "sales-entry": "Sales  Entry",
  "sales-return-entry": "Sales Return Entry",
  "outlet-sales-return": "Outlet Sales Entry",
  "cash-receipt": "Cash Receipt",
  "lab-entry": "Lab Entry", // Lab
};
export const report_modules = {
  "sales-rate-change-report": "Sales Rate Change",
  "party-sales-rate-change-report": "Party Sales Rate Change",
  "milk-purchase-individual-report": "Milk Purchase(Individual) Report", //Purchase Cycle
  "milk-purchase-balance-report": "Milk Purchase(Balance) Report",
  "other-purchase-summary-report": "Other Purchase Summary(Party wise)",
  "payslip-report-all-payslip": "Payslip Report All Payslip",
  "payslip-report-individual": "Payslip Report Individual",
  "individual-ledger-report": "Individual Ledger Report",
  "purchase-ledger-report": "Purchase Ledger",
  "purchase-report": "Purchase Report",
  "raw-milk-stock-report": "Raw Milk Stock", //Production Cycle
  "stock-valuation-report": "Stock Valuation Report",
  "stock-analysis-report": "Stock Analysis Report",
  "individual-product-stock-report": "Individual Product Stock Report",
  "print-order-bill": "Print Order Bill", //Order Processing
  "order-summery": "Order Summary",
  "print-route-wise-order-bill": "Print Route Wise Order Bill",
  "order-report": "Order Report",
  "cash-received": "Cash Received", //sales cycle
  "container-in-out-monthly": "Conatiner In/Out(Monthly)",
  "sales-reminder-bill": "Sales Reminder Bill",
  "sales-summery-report-party-wise": "Sales Summary Report(Party Wise)",
  "sales-summery-report-product-wise": "Sales Summary Report(product Wise)",
  "sales-vs-purchase": "Sales Vs Purchase",
  "sales-return-report": "Sales Return Report",
  "sales-return-damage-report-party-wise":
    "Sales Return/Damage Report(Party Wise)",
  "sales-return-damage-report-product-wise":
    "Sales Return/Damage Report(Product Wise)",
  "discount-report": "Discount Report",
  "sales-ledger": "Sales Ledger",
  "sales-person-wise-sales-report": "Sales Person Wise Sales Report",
  "individual-party-ledger-purchase": "Individual Party Ledger Purchase",
  "individual-party-ledger-sales": "Individual Party Ledger Sales",
};
export const accountingModules = {
  "economic-year-setup": "Economic Year Setup", // accounting
  ledger: "Ledger",
  "income-entry": "Income Entry",
  "ledger-group": "Ledger Group",
  "ledger-sub-group": "Ledger Sub Group",
  "expense-entry": "Expense Entry",
  "journal-entry": "Journal Voucher",
  "contra-entry": "Contra Entry",
};

export const accountingReportsModules = {
  "trial-balance": "Trial Balance",
  "trading-account": "Trading Account",
  "profit-and-loss": "Profit And Loss",
  "balance-sheet": "Balance Sheet",
  "ledger-report-individual": "Ledger Report Individual",
  "ledger-report-group-wise": "Ledger Report Group-wise",
  "day-book": "Day Book",
  "cash-book": "Cash Book",
  "ledger-group-master": "Ledger Group Master",
  "ledger-sub-group": "Ledger Sub Group",
  "fixed-assets": "Fixed Assets",
  "fixedassets-depr-booksetup": "Fixed Assets And Depriciation Book Setup",
  depriciation: "Depriciation Entry",
};

export const setting = {
  "user-registration": "User Registration", // setting
  "user-role": "User Role",
  "tax-setting": "Tax Settings",
  backup: "Backup",
  branch: "Branch",
};

export const control_panel_modules = {
  "price-plan": "Price Plan",
  "client-registration": "Client Registration",
  "client-registration-for-other-software": "Client Registration",
  "client-payment": "Client Payment",
  "active-maintainance-mode": "Active Maintainance Mode",
  "publish-notice": "Publish Notice",
  "create-user-group": "Create User Group",
  "user-registration": "User Registration",
  "reset-password": "Reset Password",
  "technical-access": "Technical Access",
  subscription: "Subscription",
  project:"Project Management",
  ticket: "Ticket",
  timesheet: "Timesheet",
  leave: "Leave",
  hrm: "HRM",
};
export const control_panel_reports = {
  "client-payment-report": "Client Payment Report",
  "client-ledger-report": "Client Ledger Report",
};
